import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@frontegg/react";
import { Box, CircularProgress } from "@mui/material";
import AppShell from "./AppShell";
import { useIsSmallScreen } from "hooks/useIsSmallScreen";
import BackToAdminAction from "../nav/BackToAdminAction";
import AddAccountAction from "../platform/dashboard/AddAccountAction";
import { usePlatformSidebarItems } from "hooks/usePlatformSidebarItems";
import { useTranslation } from "react-i18next";
import { setLastSystem } from "../../utils/lastSystem";
import { getImpersonationFromStorage } from "../../contexts/ImpersonationContext";
import { useBrandingContext } from "context/BrandingContext";

const LayoutPlatform: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth();
  const { platform } = useBrandingContext();
  const location = useLocation();

  const platformNav = usePlatformSidebarItems();

  const isSmallScreen = useIsSmallScreen();
  const [isSideBarSmallScreenOpen, setIsSideBarSmallScreenOpen] =
    useState<boolean>(false);

  const handleCollapsed = () => {
    setIsSideBarSmallScreenOpen(!isSideBarSmallScreenOpen);
  };

  useEffect(() => {
    if (!isSmallScreen) {
      setIsSideBarSmallScreenOpen(false);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    if (getImpersonationFromStorage()) return;
    setLastSystem("platform");
  }, []);

  if (isLoading)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );

  if (!isAuthenticated) return null;

  return (
    <AppShell
      basePath="/platform"
      items={platformNav.items}
      subItems={platformNav.subItems}
      isSmallScreen={isSmallScreen}
      isSideBarSmallScreenOpen={isSideBarSmallScreenOpen}
      handleCollapsed={handleCollapsed}
      footerDisclosure={platform?.footerDisclosure || t("PlatformFooterText")}
      extraActions={<BackToAdminAction />}
      leadingActions={
        // Dashboard only, and only where the bar has room: the page floats its own below `md`.
        location.pathname.startsWith("/platform/dashboard") &&
        !isSmallScreen ? (
          <AddAccountAction />
        ) : undefined
      }
    />
  );
};

export default LayoutPlatform;
